import { h, render, Component } from 'preact';

class TxrNavSubmenuProduct extends Component {
    state = {
    }
    render() {
        return (
            <div class="txr-nav-submenu product">
                <div class="submenu-mobile-back" onClick={() => this.props.onClose()}>
                    <img class="submenu-mobile-back__icon" src="/images/navigation/icon-arrow-nav.svg"></img>
                    <span class="submenu-mobile-back__text">Product</span>
                </div>
                <div class="txr-nav-submenu-content product">
                    <div class="submenu-left">
                        <div class="submenu-nav">
                            <a class="submenu-nav-item product" href="/product">
                                <i class="submenu-nav-item__icon fal fa-angle-right"></i>
                                <span class="submenu-nav-item__link">Product Overview</span>
                            </a>
                            <div class="submenu-nav__line"></div>
                            <a class="submenu-nav-item features" href="/product/features">
                                <i class="submenu-nav-item__icon fal fa-angle-right"></i>
                                <span class="submenu-nav-item__link">View All Features</span>
                            </a>
                        </div>
                        <div class="submenu-menus">
                            <div class="submenu-header">FEATURES</div>
                            <a class="submenu-item" href="/product/10dlc-registration">
                                <i class="submenu-item__image-icon fal fa-badge-check"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    10DLC Registration
                                    </div>
                                </div>
                            </a> 

                            <a class="submenu-item" href="/product/mass-texting">
                                <i class="submenu-item__image-icon fal fa-bullhorn"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                        Mass Texting
                                    </div>
                                </div>
                            </a>

                            <a class="submenu-item" href="/product/payments">
                                <i class="submenu-item__image-icon fal fa-circle-dollar"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                        Payments
                                    </div>
                                </div>
                            </a>
                            <a class="submenu-item" href="/product/reviews">
                                <i class="submenu-item__image-icon fal fa-stars"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Reviews
                                    </div>
                                </div>
                            </a>  
                        </div>
                    </div>
                    <div class="submenu-right">
                        <div class="product-apps">
                                <div class="product-apps__hint">Check out our downloads</div>
                                <div class="product-apps__line">
                                    <a href="/product/chrome-extension" class="txr-text__link">Chrome Extension</a>
                                    <span class="product-apps__rule"></span>
                                    <a href="/product/desktop-app" class="txr-text__link">Desktop App</a>
                                    <span class="product-apps__rule"></span>
                                    <a href="/product/mobile-apps" class="txr-text__link">Mobile App</a>
                                </div>
                        </div>
                        <div class="submenu-menus">
                            <div class="submenu-header">PLATFORM</div>
                            <a class="submenu-item" href="/product/sms-api">
                                <i class="submenu-item__image-icon fal fa-cog"></i>                
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    API & Developers
                                    </div>
                                </div>
                            </a>      
                            <a class="submenu-item" href="/product/hipaa">
                                <i class="submenu-item__image-icon fal fa-staff-snake"></i> 
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    HIPAA Compliant Texting
                                    </div>
                                </div>
                            </a>                                                  
                            <a class="submenu-item" href="/integrations">
                                <i class="submenu-item__image-icon fal fa-arrow-right-arrow-left"></i> 
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                        Integrations
                                    </div>
                                </div>
                            </a>
                            
                            <a class="submenu-item" href="/security">
                                <i class="submenu-item__image-icon fal fa-shield-check"></i>                                 
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                        Security
                                    </div>
                                </div>
                            </a>

                            <div class="submenu-header submenu-header__only-mobile">DOWNLOADS</div>
                            <a class="submenu-item submenu-item__only-mobile" href="/product/chrome-extension">
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Chrome Extension
                                    </div>
                                </div>
                            </a>
                            <a class="submenu-item submenu-item__only-mobile" href="/product/desktop-app">
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Desktop App
                                    </div>
                                </div>
                            </a>
                            <a class="submenu-item submenu-item__only-mobile" href="/product/mobile-apps">
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Mobile App
                                    </div>
                                </div>
                            </a>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TxrNavSubmenuProduct;

/*

                            <a class="submenu-item" href="/product/chrome-extension">
                                <img class="submenu-item__image image-width28" alt="sumbenu" src="/images/navigation/icon-mobile-apps.svg" />
                                <img class="submenu-item__image-hover image-width28" alt="sumbenu" src="/images/navigation/icon-mobile-apps-green.svg" />
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                        Chrome Extension
                                    </div>
                                    <div class="submenu-item__text">
                                        Take texting everywhere you go online. Works on Chrome and Edge.
                                    </div>
                                </div>
                            </a>

                            <a class="submenu-item" href="https://help.textrequest.com" target="_blank">
                                <img class="submenu-item__image" alt="sumbenu" src="/images/navigation/icon-knowledgebase.svg" />
                                <img class="submenu-item__image-hover" alt="sumbenu" src="/images/navigation/icon-knowledgebase-green.svg" />
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                        Help Center
                                    </div>
                                    <div class="submenu-item__text">
                                        Guides and documentation to master Text Request and answer your questions.
                                    </div>
                                </div>
                            </a>
*/